export default "__VITE_PUBLIC_ASSET__6415f0d5__"